import React from "react";
import { Center } from "@chakra-ui/react";
import { useFeature } from "@growthbook/growthbook-react";
import { useQuery } from "graphql-hooks";
import _ from "lodash";

import {
  GenericErrorAlert,
  MissingProfileDataAlert,
} from "../../components/alerts";
import { EmptyBasket } from "../../components/empty-state";
import Layout from "../../components/layout";
import Loading from "../../components/loading";
import { Col } from "../../components/paljs";
import { GetCartItemGroupsQuery } from "../../types";

import CheckoutAgreements from "./CheckoutAgreements";
import CheckoutBuy from "./CheckoutBuy";
import CheckoutCartItemGroup from "./CheckoutCartItemGroup";
import CheckoutDiscount from "./CheckoutDiscount";
import CheckoutSummary from "./CheckoutSummary";
import { GET_CART_ITEM_GROUPS } from "./data";

function CheckoutLogic() {
  const { on: showDiscounts } = useFeature("discount-codes");

  const { loading, data } =
    useQuery<GetCartItemGroupsQuery>(GET_CART_ITEM_GROUPS);

  const isIncomplete = data?.me.isIncomplete;
  const itemsGroups = data?.me.cart?.itemsGroups;
  const cartIsEmpty = _.isEmpty(itemsGroups);

  if (loading) {
    return <Loading />;
  }
  if (cartIsEmpty) {
    return <EmptyBasket />;
  }
  if (itemsGroups) {
    return (
      <>
        {isIncomplete && <MissingProfileDataAlert parent={true} />}
        {_.map(itemsGroups, (cartItemGroup, index) => (
          <CheckoutCartItemGroup key={index} />
        ))}
        <CheckoutAgreements />
        {showDiscounts && <CheckoutDiscount />}
        <CheckoutSummary />
        <CheckoutBuy />
      </>
    );
  }

  return <GenericErrorAlert />;
}

const CheckoutLayoutWrapper = ({ children }: { children: React.ReactNode }) => (
  <Layout>
    <Center>
      <Col breakPoint={{ lg: 12, xl: 10, xxxl: 9 }}>{children}</Col>
    </Center>
  </Layout>
);

export default function Checkout() {
  return (
    <CheckoutLayoutWrapper>
      <CheckoutLogic />
    </CheckoutLayoutWrapper>
  );
}
